/**
 * PasteCopyBlocker (Sprint 6 B5).
 *
 * Block:
 *   - `paste`  → severity LOW
 *   - `copy`   → severity LOW
 *   - `cut`    → severity LOW (same family)
 *
 * NOT block:
 *   - Context menu (right-click) — em không block UX bình thường vì user có thể
 *     muốn dùng dev tools / inspect element legit (ví dụ debug audio bị tắt).
 *     Devtools open detection có riêng (defer Sprint 7+).
 *
 * Behavior: `preventDefault()` + `stopPropagation()` ở pha CAPTURE của document + log violation.
 * Phải chặn ở capture: rich editor (ProseMirror/Monaco) tự đọc clipboard trong handler của chính
 * nó (chạy TRƯỚC listener bubble ở document) → chỉ `preventDefault` ở bubble là đã muộn. Toast không hiện vì có thể spam
 * khi user paste lập đi lập lại (already throttled qua queue flush 5s).
 */

import { useEffect } from "react";

interface Props {
  onViolation: (event: {
    type: "paste_attempt" | "copy_attempt";
    severity: "low";
    detail?: Record<string, unknown>;
  }) => void;
}

export function PasteCopyBlocker({ onViolation }: Props) {
  useEffect(() => {
    const handlePaste = (e: ClipboardEvent) => {
      e.preventDefault();
      e.stopPropagation();
      onViolation({
        type: "paste_attempt",
        severity: "low",
        detail: { target: (e.target as HTMLElement)?.tagName ?? "unknown" },
      });
    };
    const handleCopy = (e: ClipboardEvent) => {
      e.preventDefault();
      e.stopPropagation();
      onViolation({
        type: "copy_attempt",
        severity: "low",
        detail: { target: (e.target as HTMLElement)?.tagName ?? "unknown" },
      });
    };

    document.addEventListener("paste", handlePaste, true);
    document.addEventListener("copy", handleCopy, true);
    document.addEventListener("cut", handleCopy, true);
    return () => {
      document.removeEventListener("paste", handlePaste, true);
      document.removeEventListener("copy", handleCopy, true);
      document.removeEventListener("cut", handleCopy, true);
    };
  }, [onViolation]);

  return null;
}
